import { TDynamicVariable } from "@shared/types";
import { CoreConfig } from "../types";

export const calculateTakeoffVariable = (
  variable: TDynamicVariable,
  config: CoreConfig & {
    appendUnit?: boolean;
  }
) => {
  switch (variable.output) {
    case "VALUE":
      switch (variable.takeoffVariable) {
        case "cornerPostDistanceOnCenter":
          return config.cornerPostDistanceOnCenter;
        case "linePostDistanceOnCenter":
          return config.linePostDistanceOnCenter;
      }
  }
  return 0;
};
